import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { app } from "../../../Frame/App";
import { WidgetMeasureTreeComponent } from "../Components/WidgetMeasureTreeComponent";
import { PopupMeasureTreeComponent } from "../Popups/PopupMeasureTreeComponent";
import { DesignParser } from "../Components/Util/DesignParser";

export enum MeasureTreeTypeEnum { parent, child }
export class WidgetMeasureTreeModel{
    measureIds: number[];
    templateId: number;
    uniqueIds: string[];

    constructor() {
        this.measureIds = [];
        this.uniqueIds = [];
    }
}
export class optionsMeasureTreeModel {
    templateId: number;
    templateName: string;
    hasButtonNew: boolean;
}

export class MarkupMeasureTreeModel {
    templateId: number;
    markup: string;
}

export class WidgetMeasureTreeProps {
    public markup: MarkupMeasureTreeModel[];
    public clientId: string;
    public styles: string;
    public json: string;
    public templateId: string;
    public viewId: number;
    public templateOptions: optionsMeasureTreeModel[];

    constructor() {
        this.markup = [];
        this.viewId = 0;
        this.templateOptions = [];
    }
}
export class WidgetMeasureTree extends WidgetBase {
    props: WidgetMeasureTreeProps;
    constructor(controller: WidgetController) {
        super(controller, 1, 1);

        this.props = new WidgetMeasureTreeProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.MeasureTree;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (!this.props.markup)
                this.props.markup = [];
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    showPopup(): void {
        let popup = new PopupMeasureTreeComponent({ widget: this });
        document.body.appendChild(popup.render());
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number, paramter?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetMeasureTreeComponent({
            widget: this,
            clientId: this.props.clientId,
            measureId: parseInt((document.getElementById("ParentId") as HTMLInputElement).value) ? parseInt((document.getElementById("ParentId") as HTMLInputElement).value) : paramter,
            markup: this.props.markup,
            styles: this.props.styles,
            json: this.props.json,
            templateId: this.props.templateId,
            viewId: this.props.viewId,
            templateOptions: this.props.templateOptions
        });

        let renderedElement = this.component.render();
        DesignParser.setScrollPosition();
        return renderedElement;
    }
}